import { render } from "./hospital.vue?vue&type=template&id=010b2524"
import script from "./hospital.vue?vue&type=script&lang=js"
export * from "./hospital.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__